import { USER_ROLE_AGENT } from 'common/userRoles';

import { SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE } from 'api/actionTypes';

export default async function getAgentsList({ state, apiClient }) {
  if (state.get(['tourAgents'])) {
    return;
  }
  await apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE,
    payload: {
      userRole: USER_ROLE_AGENT,
    },
    queryId: USER_ROLE_AGENT,
    state: state,
    onSuccess(tourAgents) {
      state.set(['tourAgents'], tourAgents);
    },
  });
}
